// import { Project, GetClientsBasicQuery, Note } from "@overwatch/graphql";
import { createContext } from 'react';

import { type UploadedFile } from './types';

import { type GetClientsBasicQuery, type Note, type Project } from '@/graphql/generated/graphql';

interface FunnelContextValueType {
  notes: Pick<Note, 'id' | 'description'>[];
  loading: boolean;
  projects: Project[];
  fileUploading: boolean;
  files: UploadedFile[];
  selectedProject: Project | undefined;
  clients: GetClientsBasicQuery['getClients'];
  selectedClient: NonNullable<GetClientsBasicQuery['getClients']>[0] | undefined;
  onDocumentsSent: () => void;
  onCreateProject: () => void;
  onFileRemove: (fileId: string) => void;
  deleteProjectNote: (id: string) => void;
  onProjectSelect: (project: Project) => void;
  createProjectNote: (description: string) => void;
  onFileUpload: (uploadedFiles: File[]) => Promise<void>;
  updateProjectNote: (id: string, description: string) => void;
  onClientSelect: (client: NonNullable<GetClientsBasicQuery['getClients']>[0]) => void;
}

const FunnelContext = createContext<FunnelContextValueType>({
  files: [],
  notes: [],
  clients: [],
  projects: [],
  loading: false,
  fileUploading: false,
  selectedClient: undefined,
  selectedProject: undefined,
  onDocumentsSent: () => {},
  onCreateProject: () => {},
  onFileRemove: (_fileId: string) => {},
  deleteProjectNote: (_id: string) => {},
  createProjectNote: (_description: string) => {},
  onProjectSelect: (_project: Project) => undefined,
  onFileUpload: (_uploadedFiles: File[]) => Promise.resolve(),
  updateProjectNote: (_id: string, _description: string) => {},
  onClientSelect: (_client: NonNullable<GetClientsBasicQuery['getClients']>[0]) => undefined,
});

export default FunnelContext;
